module.exports = __webpack_public_path__ + "static/media/associateOr2.bdbd7243.JPG";